// extracted by mini-css-extract-plugin
module.exports = {"title":"PartsNeeded_title__2TNEt","addPart":"PartsNeeded_addPart__1SN2u","hoursNeededLabel":"PartsNeeded_hoursNeededLabel__3z4nK","mainButton":"PartsNeeded_mainButton__3pRaJ"};